/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconCloseFilled12 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseFilled12(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 12 12" ref={ref}>
            <path
                d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12Zm1.803-8.864a.75.75 0 1 1 1.06 1.06L7.062 6l1.803 1.803a.75.75 0 1 1-1.06 1.06L6 7.062 4.197 8.864a.75.75 0 1 1-1.06-1.06L4.938 6 3.136 4.197a.75.75 0 1 1 1.06-1.06L6 4.938l1.803-1.803Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCloseFilled16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseFilled16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm2.404-11.818a1 1 0 1 1 1.414 1.414L9.414 8l2.404 2.404a1 1 0 0 1-1.414 1.414L8 9.414l-2.404 2.404a1 1 0 0 1-1.414-1.414L6.586 8 4.182 5.596a1 1 0 0 1 1.414-1.414L8 6.586l2.404-2.404Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCloseFilled20 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseFilled20(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 20 20" ref={ref}>
            <path
                d="M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10ZM5.403 5.403a1 1 0 0 1 1.414 0L10 8.586l3.183-3.183a1 1 0 1 1 1.414 1.414L11.414 10l3.183 3.183a1 1 0 0 1-1.414 1.414L10 11.414l-3.183 3.183a1 1 0 0 1-1.414-1.414L8.586 10 5.403 6.817a1 1 0 0 1 0-1.414Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconCloseFilled24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseFilled24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10ZM7.403 7.403a1 1 0 0 1 1.414 0L12 10.586l3.183-3.183a1 1 0 1 1 1.414 1.414L13.414 12l3.183 3.183a1 1 0 0 1-1.414 1.414L12 13.414l-3.183 3.183a1 1 0 0 1-1.414-1.414L10.586 12 7.403 8.817a1 1 0 0 1 0-1.414Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconCloseFilled = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconCloseFilled(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '12':
            return <IconCloseFilled12 {...iconProps} />;
        case '16':
            return <IconCloseFilled16 {...iconProps} />;
        case '20':
            return <IconCloseFilled20 {...iconProps} />;
        case '24':
            return <IconCloseFilled24 {...iconProps} />;
        default:
            return <IconCloseFilled24 {...iconProps} />;
    }
});
